import { render } from "./ChatSidebar.vue?vue&type=template&id=ce8673b8&scoped=true"
import script from "./ChatSidebar.vue?vue&type=script&lang=js"
export * from "./ChatSidebar.vue?vue&type=script&lang=js"

import "./ChatSidebar.vue?vue&type=style&index=0&id=ce8673b8&scoped=true&lang=css"
import "./ChatSidebar.vue?vue&type=style&index=1&id=ce8673b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8673b8"]])

export default __exports__